import { CHARACTER_TYPES } from './../../f.assets/Characters/scripts/constants'
import { Vector2, Vector3 } from 'three'
import { MAGIC_TYPE } from '../../f.assets/Characters/scripts/constants'
import { TreasureConfig } from './../../f.assets/Characters/scripts/classes/TreasureConfig'
export enum BATTLE_STATES {
  INITIAL = 'battle_initial',
  ONGOING = 'battle_on_going',
  ENDED = 'battle_ended',
  CHARGE = 'battle_charge',
  ACTION = 'battle_action',
}

export enum TURN_STATES {
  IDLE = 'TURN_IDLE',
  MOVE = 'TURN_MOVE',
  ATTACK = 'TURN_ATTACK',
  ARMED = 'TURN_ARMED',
  AWAIT = 'TURN_AWAIT',
  DEAL_DAMAGE = 'TURN_DEAL_DAMAGE',
}

export enum COMMANDERS {
  PLAYER = 'PLAYER',
  COM = 'COM1',
  NOBODY = 'NOBODY',
}
export enum SPELL_TARGET_TYPE {
  ANY_CREATURE = 'ANY_CREATURE',
  MY_CREATURES = 'MY_CREATURES',
  ENEMY_CREATURES = 'ENEMY_CREATURES',
  MY_TREASURE = 'MY_TREASURE',
  ENEMY_TREASURE = 'ENEMY_TREASURE',
  TERRAIN = 'TERRAIN', // tile in terrain
  GAME = 'GAME', // no particula target, just use the spell like to get mana
}
export enum SPELL_TYPE {
  GRAVE = 'GRAVE',
  SPARK = 'SPARK',
  CANDY_SWORD = 'CANDY_SWORD',
  DEVIL_MINION = 'DEVIL_MINION',
  PETRIFY_MINION = 'PETRIFY_MINION',
  FIREBALL = 'FIREBALL',
  MASTER = 'MASTER',
}
export type Spell = {
  id: number
  targetType: SPELL_TARGET_TYPE
  type: SPELL_TYPE
  name: string
  icon: string
  cost: number
  description: string
}
export type MagicConfig = {
  owner: COMMANDERS
  destination: Vector3
  type: MAGIC_TYPE
}
export type Player = {
  id: string
  name?: string
  team?: CHARACTER_TYPES.JACK | CHARACTER_TYPES.WITCH
  level: number
  manaLevel?: number
  maxManaLevel?: number
  // all the available spells
  spells: Spell[]
  // those on deck to be casted
  activeSpells: Spell[]
  magicThrown?: MagicConfig
}
export type Character = {
  type: CHARACTER_TYPES
  owner: COMMANDERS
  coords: Vector2
  tickDivisions: number[]
  variant?: CHARACTER_VARIANTS
}
export type Treasure = {
  owner: COMMANDERS
  coords: Vector2
  amount: number
}
export type Candy = {
  coords: Vector2
}
export type ObstacleConfig = {
  type: OBSTACLE_TYPE
  coords: Vector2
}
export type LevelConfig = {
  id: string
  players: Player[]
  characters: Character[]
  treasures: Treasure[]
  obstacles: ObstacleConfig[]
}

export type ManaByPlayer = Record<
  COMMANDERS.PLAYER | COMMANDERS.COM,
  {
    manaLevel: number
    maxManaLevel: number
  }
>
export type LevelSlice = {
  levels: {
    data: {
      battleState: BATTLE_STATES
      troopOwners: COMMANDERS[]
      turnOwner?: COMMANDERS
      turnState: TURN_STATES
      players: Player[]
      manaLevelsByPlayer: ManaByPlayer
      selectedSpellIdx?: number
      checklistToGo: Record<string, boolean>
    }
    // setPlayerTeam: (team: CHARACTER_TYPES.JACK | CHARACTER_TYPES.WITCH) => void
    resetLevel: () => void
    checkItemToGo: (task: string) => void
    setBattleState: (state: BATTLE_STATES) => void
    setTurnOwner: (state: COMMANDERS) => void
    setTurnState: (state: TURN_STATES) => void
    bootUp: () => void
    startBattle: () => void
    hasAvailableUnits: () => boolean
    isActionableUnit: (coords: Vector2) => boolean
    isTargetUnit: (coords: Vector2) => boolean
    setPlayers: (players: Players[]) => void
    setManaConfig: (commander: COMMANDERS, config: typeof ManaByPlayer) => void
    updateMana: (commander: COMMANDERS, diff: number) => void
    setSelectedSpellIdx: (idx: number) => void
    clearSelectedSpellIdx: () => void
    setCastedSpell: (spell: Spell, owner: COMMANDERS) => void
    throwMagic: (commander: COMMANDERS, targetPosition: Vector3, magicType: MAGIC_TYPE) => void
    clearThrowMagic: (commander: COMMANDERS) => void
  }
}
